import { render, staticRenderFns } from "./BDmap2.vue?vue&type=template&id=6d624b18&scoped=true&"
import script from "./BDmap2.vue?vue&type=script&lang=js&"
export * from "./BDmap2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d624b18",
  null
  
)

export default component.exports